var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIcoShoppingCart = function SvgIcoShoppingCart(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M1 0a1 1 0 1 0 0 2h1.663l2.353 13.176A1 1 0 0 0 6 16a2 2 0 1 0 0 4 2 2 0 0 0 0-4h10a2 2 0 1 0 0 4 2 2 0 0 0 0-4 1 1 0 1 0 0-2H6.837l-.357-2H17a1 1 0 0 0 .949-.684l2-6A1 1 0 0 0 19 4H5.052L4.484.824A1 1 0 0 0 3.5 0zm4.422 6 .712 4h10.145l1.334-4z",
    clipRule: "evenodd"
  })));
};
export default SvgIcoShoppingCart;